import url_acc from '@/urls/accounts'
import { sendDeleteRequest, sendPostRequest, sendPutRequest } from '@/helper/requests'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  createUserLanguage: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Создает язык пользователя
     * @param {Object} commit - контекст Vuex
     * @param {Object} data - данные языка для создания
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = url_acc.PROFILE.LANGUAGE.CREATE()
    sendPostRequest(
      url, data, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  },
  updateUserLanguage: ({ commit }, { data, id, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Обновляет язык пользователя
     * @param {Object} commit - контекст Vuex
     * @param {Object} data - обновленные данные языка
     * @param {string|number} id - идентификатор языка
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = url_acc.PROFILE.LANGUAGE.UPDATE(id)
    sendPutRequest(
      url, data, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  },
  deleteUserLanguage: ({ commit }, { id, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Удаляет язык пользователя
     * @param {Object} commit - контекст Vuex
     * @param {string|number} id - идентификатор языка
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = url_acc.PROFILE.LANGUAGE.DELETE(id)
    sendDeleteRequest(
      url, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  }
}
export default {
  state,
  mutations,
  getters,
  actions
}
